
































import { mapGetters } from 'vuex';

export default {
    name: 'JobRequirementUniversity',

    props: {
        universities: {
            required: true,
            type: Array,
        },

        canModifyJob: {
            default: false,
            required: false,
            type: Boolean,
        },

        completed: {
            default: null,
            required: false,
            type: [Boolean, null],
        },
    },

    computed: {
        ...mapGetters('jobs/single', {
            job: 'getSingleJob',
        }),

        ...mapGetters('global/universities', {
            partners: 'getPartnerUniversities',
        }),

        universityNames() {
            let arr = [];
            this.universities?.forEach((university) => {
                arr.push(this.partners.find((partner) => partner.code === university.meta.university)?.name);
            });
            return arr;
        },
    },

    created() {
        this.fetchPartnerUniversities();
    },

    methods: {
        async fetchPartnerUniversities() {
            await this.$store.dispatch('global/universities/fetchPartnerUniversities');
        },

        edit() {
            this.$emit('open-draft', 2, '#preferred-universities');
        },
    },
};
